import { render, staticRenderFns } from "./dispatch_logs.vue?vue&type=template&id=8a648b38&scoped=true"
import script from "./dispatch_logs.vue?vue&type=script&lang=js"
export * from "./dispatch_logs.vue?vue&type=script&lang=js"
import style0 from "./dispatch_logs.vue?vue&type=style&index=0&id=8a648b38&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a648b38",
  null
  
)

export default component.exports